import get from 'lodash/get';
import {
    MINI_PDP_ON_OPEN,
    MINI_PDP_ON_CLOSE,
    MINI_PDP_ON_MODE_CHANGE,
    SELECT_PRODUCT,
    MINI_PDP_PERSIST_ERROR,
    MINI_PDP_CLOSE_ERROR,
    MINI_PDP_OPEN_ERROR,
    MINI_PDP_ON_DYNAMIC_GALLERIES_OPEN,
    MINI_PDP_ON_DYNAMIC_GALLERIES_CLOSE,
    MINI_PDP_ON_SHOP_THE_IMAGE_OPEN,
    MINI_PDP_ON_SHOP_THE_IMAGE_CLOSE,
    MINI_PDP_ON_SHOP_THE_LOOK_OPEN,
    MINI_PDP_ON_SHOP_THE_LOOK_CLOSE,
    MINI_PDP_ON_STYLED_FOR_YOU_OPEN,
    MINI_PDP_ON_STYLED_FOR_YOU_CLOSE,
    MINI_PDP_ATC_FROM_STL,
    MINI_PDP_ON_SHOP_THE_SET_OPEN,
    MINI_PDP_ON_SHOP_THE_SET_CLOSE,
    MINI_PDP_ATC_FROM_STS,
    MINI_PDP_ATC_FROM_DG,
    MINI_PDP_ATC_FROM_STYLEDFORYOU,
    MINI_PDP_ATC_FROM_SHOP_THE_IMAGE,
} from '../actionTypes/MiniPDPActionTypes';
import { UPDATE_ITEM_SUCCESS, UPDATE_ITEM_FAIL } from '../actionTypes/UpdateItemActionTypes';

function getParamFromUrl(params, url) {
    const reg = new RegExp(`[?&]${params}=([^&#]*)`, 'i');
    const string = reg.exec(url);
    return string ? string[1] : null;
}

export const SLIDER_MODE = {
    PRODUCT_OPTIONS: 'PRODUCT_OPTIONS',
    ALERTS_SIGNUP: 'ALERTS_SIGNUP',
    LIMITED_WARRANTY: 'LIMITED_WARRANTY',
    PROTECTION_PLAN: 'PROTECTION_PLAN',
};

const MiniPDPReducer = function MiniPDPReducer(
    state = { mode: SLIDER_MODE.PRODUCT_OPTIONS },
    action
) {
    switch (action.type) {
        case MINI_PDP_ON_OPEN: {
            const selectedSKUId =
                action.payload.skuId ||
                getParamFromUrl('selectedSKUId', get(action, 'payload.url', ''));
            const facetSelected = getParamFromUrl('facetSelected', get(action, 'payload.url', ''));
            return {
                ...state,
                ppId: action.payload.ppId,
                selectedSKUId,
                facetSelected,
                pdpUrl: action.payload.url,
                addToCartLocation: action.payload.location,
                showMiniPDP: true,
                mode: SLIDER_MODE.PRODUCT_OPTIONS,
            };
        }
        case MINI_PDP_ON_CLOSE: {
            return {
                ...state,
                showMiniPDP: false,
            };
        }

        case MINI_PDP_ON_MODE_CHANGE: {
            return {
                ...state,
                mode: action.payload,
            };
        }

        case MINI_PDP_PERSIST_ERROR: {
            return {
                ...state,
                persistError: true,
            };
        }

        case MINI_PDP_OPEN_ERROR: {
            return {
                ...state,
                error: true,
            };
        }

        case MINI_PDP_CLOSE_ERROR: {
            return {
                ...state,
                error: false,
            };
        }

        case SELECT_PRODUCT: {
            if (state.persistError) {
                return {
                    ...state,
                    error: true,
                };
            }

            return { ...state, selectedProduct: action.payload };
        }
        case UPDATE_ITEM_SUCCESS: {
            return { ...state, isUpdateItemSuccess: true, updatedItem: action.updateListResult };
        }
        case UPDATE_ITEM_FAIL: {
            return { ...state, isUpdateItemSuccess: false, updatedItem: action };
        }
        case MINI_PDP_ON_DYNAMIC_GALLERIES_OPEN: {
            return {
                ...state,
                miniPDPDG: 'open',
                itemIdDG: action.itemId ? action.itemId : '',
            };
        }
        case MINI_PDP_ON_DYNAMIC_GALLERIES_CLOSE: {
            return {
                ...state,
                miniPDPDG: 'close',
            };
        }
        case MINI_PDP_ON_STYLED_FOR_YOU_OPEN: {
            return {
                ...state,
                miniPDP_SFY: 'open',
                itemIdSFY: action.itemId ? action.itemId : '',
            };
        }
        case MINI_PDP_ON_STYLED_FOR_YOU_CLOSE: {
            return {
                ...state,
                miniPDP_SFY: 'close',
            };
        }
        case MINI_PDP_ATC_FROM_DG: {
            return {
                ...state,
                miniPDPDGATC: action.payload,
            };
        }
        case MINI_PDP_ATC_FROM_STYLEDFORYOU: {
            return {
                ...state,
                miniPDP_SFY_ATC: action.payload,
            };
        }
        case MINI_PDP_ATC_FROM_SHOP_THE_IMAGE: {
            return {
                ...state,
                miniPDP_STI_ATC: action.payload,
            };
        }
        case MINI_PDP_ON_SHOP_THE_IMAGE_OPEN: {
            return {
                ...state,
                miniPDP_STI: 'open',
                itemIdSTI: action.itemId ? action.itemId : '',
            };
        }
        case MINI_PDP_ON_SHOP_THE_IMAGE_CLOSE: {
            return {
                ...state,
                miniPDP_STI: 'close',
            };
        }
        case MINI_PDP_ON_SHOP_THE_LOOK_OPEN: {
            return {
                ...state,
                miniPDPSTL: 'open',
                itemIdSTL: action.itemId ? action.itemId : '',
            };
        }
        case MINI_PDP_ON_SHOP_THE_LOOK_CLOSE: {
            return {
                ...state,
                miniPDPSTL: 'close',
            };
        }
        case MINI_PDP_ATC_FROM_STL: {
            return {
                ...state,
                miniPDPSTLATC: action.payload,
            };
        }
        case MINI_PDP_ON_SHOP_THE_SET_OPEN: {
            return {
                ...state,
                miniPDPSTS: 'open',
                itemIdSTS: action.itemId ? action.itemId : '',
            };
        }
        case MINI_PDP_ON_SHOP_THE_SET_CLOSE: {
            return {
                ...state,
                miniPDPSTS: 'close',
            };
        }
        case MINI_PDP_ATC_FROM_STS: {
            return {
                ...state,
                miniPDPSTSATC: action.payload,
            };
        }
        default:
            return state;
    }
};

MiniPDPReducer.reducerName = 'miniPDP';

export default MiniPDPReducer;
